import React from 'react';

export const UrlIcon = ({ width = 20, height = 20, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33331 11.6667C8.60488 11.9438 8.92902 12.164 9.28675 12.3143C9.64448 12.4647 10.0286 12.5421 10.4166 12.5421C10.8047 12.5421 11.1888 12.4647 11.5465 12.3143C11.9043 12.164 12.2284 11.9438 12.5 11.6667L15.8333 8.33332C16.3858 7.78079 16.6963 7.03139 16.6963 6.24999C16.6963 5.46859 16.3858 4.71919 15.8333 4.16666C15.2808 3.61412 14.5314 3.30371 13.75 3.30371C12.9686 3.30371 12.2192 3.61412 11.6666 4.16666L11.25 4.58332"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 8.33331C11.3951 8.05615 11.0709 7.83595 10.7132 7.68563C10.3555 7.53531 9.97135 7.45789 9.58332 7.45789C9.19529 7.45789 8.81116 7.53531 8.45343 7.68563C8.0957 7.83595 7.77155 8.05615 7.49999 8.33331L4.16666 11.6666C3.61412 12.2192 3.30371 12.9686 3.30371 13.75C3.30371 14.5314 3.61412 15.2808 4.16666 15.8333C4.71919 16.3858 5.46859 16.6963 6.24999 16.6963C7.03139 16.6963 7.78079 16.3858 8.33332 15.8333L8.74999 15.4166"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
